<div class="main-footer" [ngStyle]="styleObj">
  <div class="flex items-center justify-center">
    <span>Copyright © {{ archiveInfo.copyright }}</span>
  </div>
  <div class="mt-1 flex items-center justify-center">
    @if (archiveInfo.gonganwangbei) {
      <a
        class="flex items-center"
        style="color: rgba(0, 0, 0, 0.65)"
        target="_blank"
        href="https://beian.mps.gov.cn/#/query/webSearch"
        ><img
          class="mr-1 h-4 w-auto"
          draggable="false"
          src="https://ssl-cdn.linkworld.cn/ghs.png"
        />
        <span>{{ archiveInfo.gonganwangbei }}</span>
      </a>
      <span class="mx-1">|</span>
    }
    @if (archiveInfo.beianhao) {
      <a
        style="color: rgba(0, 0, 0, 0.65)"
        target="_blank"
        href="https://beian.miit.gov.cn/"
        >{{ archiveInfo.beianhao }}
      </a>
    }
    <span class="mx-1">|</span>Legal Notices<span class="mx-1">|</span>Privacy &amp;
    Opt-Out
  </div>
</div>
